module.exports = __webpack_public_path__ + "static/media/dj.40db49c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/dj.png
// module id = 1832
// module chunks = 0